import React from 'react';
import ReactDOM from 'react-dom';
import "font-awesome/css/font-awesome.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import './index.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
